import api from '../../../components/api'
import { AutomationSchedule, DefaultFollowUpAutomationSchedule, GeneralSettings, PaymentScheduleOptions, ProposalSettings, ProposalTermsAndConditions, TenantLink } from './proposalSettings'

export const getProposalSettings = async (): Promise<ProposalSettings>=> {
  return (await api.get(`/web/proposals/settings`)).data
}

export const updatePaymentScheduleOptions = async (settings: PaymentScheduleOptions): Promise<void> => {
  return (await api.post(`/web/proposals/settings/payment-schedule-options`, settings)).data
}

export const updateGeneralSettings = async (settings: GeneralSettings): Promise<void> => {
  return (await api.post(`/web/proposals/settings/general-settings`, settings)).data
}

export const updateTermsAndConditions = async (settings: ProposalTermsAndConditions): Promise<void> => {
  return (await api.post(`/web/proposals/settings/terms-and-conditions`, settings)).data
}

type TenantLinksResponse = {
  links: TenantLink[]
}

export const getLinks = async (): Promise<TenantLink[]> => {
  return (await api.get<TenantLinksResponse>(`/web/proposals/settings/links`)).data.links
}

export const updateLinks = async (links: TenantLink[]): Promise<void> => {
  return (await api.post(`/web/proposals/settings/links`, links)).data
}

export const getDefaultFollowUpSchedule = async (): Promise<DefaultFollowUpAutomationSchedule> => {
  return (await api.get<DefaultFollowUpAutomationSchedule>(`/web/proposals/settings/default-follow-up-schedule`)).data
}

export const updateDefaultFollowUpSchedule = async (schedule: AutomationSchedule): Promise<void> => {
  return (await api.post(`/web/proposals/settings/default-follow-up-schedule`, {
    enabled: schedule.enabled,
    automation: {
      steps: schedule.steps
    }
  })).data
}
